import { Injectable } from '@angular/core';
import { BreadCrumb, BreadCrumbConfig } from '@veritas-core/models/breadcrumb';
import { Routes } from '@veritas-shared/models/routes';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  public getUpgraded = (value: BreadCrumbConfig): BreadCrumb[] => {
    const { breadcrumbs, path, route, url, resourceKey } = value;

    if (route?.routeConfig?.data?.breadcrumbHidden) return breadcrumbs;
    const breadcrumb = new BreadCrumb(resourceKey, url);

    if (!breadcrumb?.url || path.indexOf('/') === -1) return [...breadcrumbs, breadcrumb];
    // We maintain empty node because subsequently we will replaced LAST empty node with dynamic value
    // loaded by this.sessionService.setPageTitle(DYNAMIC_NODE_TITLE)
    const result = new BreadCrumb('', `${url}${path.split('/')[0]}/`);
    return [...breadcrumbs, result, breadcrumb];
  }

  public getClearedUp = (breadCrumb: BreadCrumb[], pageTitle?: string): BreadCrumb[] => {
    const nodesCount: number = breadCrumb?.length - 1;
    const nodesConfigured: BreadCrumb[] = breadCrumb?.map((item: BreadCrumb, index: number) => {
      const title = nodesCount === index ? pageTitle : null;
      return this.getWithResource(item, title);
    });
    
    // There isn't a pageTitle to configure,
    // remove all nodes without a name to avoid empty nodes
    if (!pageTitle) return nodesConfigured?.filter((item: BreadCrumb) => item?.resourceKey?.trim()?.length);

    // Remove all empty nodes and maintain only last one.
    // It will be replace in a second moment with pageTitle
    const nodes = nodesConfigured?.filter((item: BreadCrumb, index: number) => nodesCount === index || item?.resourceKey?.trim()?.length);
    return nodes;
  }

  private getWithResource = (breadCrumb: BreadCrumb, pageTitle?: string): BreadCrumb => {
    // We can set a dynamic node name thanks this.sessionService.setPageTitle(DYNAMIC_NODE_TITLE)
    // at the end of the breadcrumb => check if there is a dynamic node name and config it into breadcrumb.
    if (pageTitle) return { ...breadCrumb, resourceKey: pageTitle };
    if (breadCrumb?.resourceKey?.trim()?.length) return breadCrumb;

    const splitted = breadCrumb?.url?.split("/")?.map(value => value?.trim()?.length ? value : null)?.filter(value => Boolean(value));
    const parentRoute = Routes.routerPaths.find(el => el.path === splitted[0]);
    if (!parentRoute) return breadCrumb;

    const sonRoute = parentRoute.children.find(el => el.path === splitted[1]);
    if (sonRoute) breadCrumb.resourceKey = sonRoute.data['resourceKey'];
    return breadCrumb;
  }
}

